import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor() { }

  convertToLocal(object): any {
    for (let [key, value] of Object.entries(object)) {
      if (typeof value === 'string' && value.length >= 16 && moment(value, moment.ISO_8601, true).isValid() === true) {
        object[key] = moment.utc(value).local().format('YYYY-MM-DDTHH:mm:ss');
      }
    }
    return object;
  }

  convertAlltoLocal(objects): any {
    objects.forEach((object) => {
      object = this.convertToLocal(object);
    });
    return objects;
  }


  convertToISO(object): any {
    for (let [key, value] of Object.entries(object)) {
      if (typeof value === 'string' && value.length >= 16 && moment(value, moment.ISO_8601, true).isValid() === true) {
        object[key] = moment(value).utc().format('YYYY-MM-DDTHH:mm:ss');
      }
    }
    return object;
  }
}
